
export class Surface {
    map;
    balise;
    clickLong;
    clickMesure;
    pointMesure;
    movePoint;
    flightPath;
    fixePoint;
    isActive;
    surfaceArray;
    mouvePointImg;
    constructor(map) {
        this.map = map;
        const longueurLink = document.createElement("a");
        longueurLink.textContent = "Aire";
        longueurLink.className = 'w-auto inactive';
        longueurLink.href = "#";
        longueurLink.id = "Area";
        longueurLink.title = trans.get('common.remove');
        const that = this;
        longueurLink.addEventListener('click', function() {
            that.onClickMenu.bind(that);
            that.onClickMenu();
        });
        this.fixePoint = [];
        this.pointMesure = [];
        this.balise = longueurLink;
        this.surfaceArray=[];
        this.mouvePointImg = document.createElement('div');
        this.mouvePointImg.className = 'mesure';
    }
    getItemMenu() {
        return this.balise;
    }
    onClickMenu(){
        // nous etions en mode "actif" 
        if (this.isActive) {
            // on desactive
            this.map.setOptions({ draggableCursor: 'grab' });
            this.balise.classList.remove('active');
            this.balise.classList.add('inactive');
            google.maps.event.clearListeners(this.map, 'click');
            google.maps.event.clearListeners(this.map, 'mousemove');
            this.clickMesure = 0;
            
            this.isActive = false;
        } else {
            this.clickMesure = 0;
            // on réinitialise les champs et on active le mode
            if(this.movePoint) {
                this.movePoint.setMap(null);
                this.movePoint.position = null;
                this.movePoint = null;
            }
            this.fixePoint.forEach((element) => {
                element.setMap(null);
                element.position=null;
                element = null;
            });
            this.fixePoint = [];
            if(this.flightPath) {
                this.flightPath.setPath(this.pointMesure);
                this.flightPath.setMap(null);
                this.flightPath = null;
            }
            this.pointMesure = [];
            this.surfaceArray=[];

            this.balise.classList.remove('inactive');
            this.balise.classList.add('active');
            this.map.setOptions({ draggableCursor: 'crosshair' });
            // on supprime 
            google.maps.event.clearListeners(this.map, 'click');
            // on ajoute les event listeners
            const that = this;
            google.maps.event.addListener(this.map, "click", function(e) {
                that.handleClickOnMap.bind(that);
                that.handleClickOnMap(e);
            });
            google.maps.event.addListener(this.map, "mousemove", function(e) {
                that.handleMouseMoveOnMap.bind(that);
                that.handleMouseMoveOnMap(e);
            });
            this.isActive = true;
        }
    }
    handleClickOnMap(evt) {
        this.clickMesure++;
        var path = this.pointMesure;
        if (this.clickMesure == 1) {
            this.flightPath = new google.maps.Polygon({
                path:path,
                map:null,
                geodesic: true,
                strokeColor: "#FF0000",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                clickable:false,
                editable: true,
                dragable:false,
            });

            this.movePoint = new google.maps.marker.AdvancedMarkerElement({
                map: null,
                content : this.mouvePointImg
            });

            const that = this;
            google.maps.event.addListener(this.flightPath, "click", function(e) {
                
                if(e.vertex>0){
                  that.pointMesure.push({
                    "lat":e.latLng.lat(),
                    "lng":e.latLng.lng(),
                  });
                  that.clickMesure++;
                }else{
                  that.pointMesure.pop();
                  that.flightPath.setPaths(that.pointMesure);
                  google.maps.event.clearListeners(that.map, 'mousemove');
                  that.flightPath.setEditable(false);
                }
                  
              });

            this.flightPath.setMap(this.map);
            this.movePoint.setMap(this.map);
        }
        let latLng = evt.latLng;
        let lat = latLng.lat();
        let lng = latLng.lng();
        this.pointMesure.push({
            'lat': lat,
            'lng': lng,
        });
        this.surfaceArray.push([lng, lat]);        
    }
    handleMouseMoveOnMap(evt) {
        if (this.pointMesure.length > 0) {
            this.pointMesure[this.clickMesure] = {
                'lat': evt.latLng.lat(),
                'lng': evt.latLng.lng(),
            };
            this.surfaceArray.splice(this.clickMesure,1,[evt.latLng.lng(),evt.latLng.lat()]);
            var area=0;
            if(this.surfaceArray.length>=3){
              var surfTemp = [];
              surfTemp =  JSON.parse(JSON.stringify(this.surfaceArray));
              surfTemp.push(this.surfaceArray[0]);
             
              var temp = turf.polygon([surfTemp]);
              var temp2 = turf.points(this.surfaceArray);
              var center= turf.center(temp2).geometry.coordinates;
              area = Math.round(turf.area(temp));

                this.mouvePointImg.textContent = area + " m²";

                this.movePoint.position = {
                    'lat' :  center[1]+0.0001,
                    'lng' : center[0],
                }
            }

            this.flightPath.setPath(this.pointMesure);
        }
    }
}
export default Surface;